// extracted by mini-css-extract-plugin
export default {"wrapper":"classicMenu_wrapper__MrAZL","container":"classicMenu_container__1MR2l","menuItem":"classicMenu_menuItem__AgOvH","selected":"classicMenu_selected__U1rBN"};